import * as error from "../lib/api/error";
import * as routes from "../constants/routes";
import React, {Component, ErrorInfo, ReactNode} from "react";
import {Redirect} from "react-router-dom";
import {RouteComponentProps, withRouter} from "react-router";

const IS_DEV = process.env.NODE_ENV === "development";

const strings = {
    somethingWentWrong: "Something went wrong.",
};

type Props = {
    children: ReactNode;
};

type State = {
    errored: boolean;
};

class ErrorBoundary extends Component<RouteComponentProps & Props, State> {
    state = {
        errored: false,
    };

    componentDidCatch(err: Error, errorInfo: ErrorInfo) {
        error.reportRender(err, errorInfo);
        this.setState({errored: true});
    }

    render() {
        if (this.state.errored) {
            const routerState =
                typeof this.props.location.state === "object" ? this.props.location.state : {};
            return IS_DEV ? (
                <div>{strings.somethingWentWrong}</div>
            ) : (
                <Redirect
                    to={{
                        pathname: routes.ERROR,
                        search: window.location.search,
                        state: {
                            ...routerState,
                            destination: this.props.location.pathname,
                        },
                    }}
                />
            );
        }
        return this.props.children;
    }
}

export default withRouter(ErrorBoundary);
